<template>
  <p>
    {{ libraryNetworkName }}
  </p>
 </template>

<script>
  export default {
    
    props: {
      municipalitiesLibraryNetworks: Object,
      municipalityId: String,
    },

    computed: {
      libraryNetworkName: function() {
        return this.municipalitiesLibraryNetworks[this.municipalityId] || ''
      }
    },

  }
</script>
